import { useEffect, useRef } from 'react';
import L from 'leaflet';

interface GeofenceCircleProps {
  map: L.Map;
  lat: number;
  lng: number;
  radiusMeters: number;
  isInside: boolean;
  storeName?: string;
}

export default function GeofenceCircle({
  map,
  lat,
  lng,
  radiusMeters,
  isInside,
  storeName,
}: GeofenceCircleProps) {
  const circleRef = useRef<L.Circle | null>(null);

  useEffect(() => {
    const color = isInside ? '#22c55e' : '#ef4444';

    const circle = L.circle([lat, lng], {
      radius: radiusMeters,
      color,
      fillColor: color,
      fillOpacity: 0.1,
      weight: 2,
      dashArray: isInside ? undefined : '8, 4',
    }).addTo(map);

    if (storeName) {
      circle.bindTooltip(storeName, {
        permanent: false,
        direction: 'top',
      });
    }

    circleRef.current = circle;

    return () => {
      circle.remove();
    };
  }, [map, lat, lng, radiusMeters, isInside, storeName]);

  return null;
}
